import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useVerifyEmail } from '@data';
import { antdNotification } from '@ui/components';
import { useSignUpTracking } from '../../TrialManagerSignUp/hooks';

export const useEmailVerification = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const { mutate: verifyEmail } = useVerifyEmail();
  const { trackEmailVerified } = useSignUpTracking();

  const code = searchParams.get('oobCode');
  const mode = searchParams.get('mode');

  useEffect(() => {
    if (code && mode === 'verifyEmail') {
      verifyEmail(
        { code },
        {
          onSuccess: () => {
            antdNotification.success({ title: t('sign_in_page.email_verified') });
            trackEmailVerified();
          },
        },
      );
    }
  }, [code, mode]);
};
